import Image from 'next/image';
import Link from 'next/link';
import { memo } from 'react';
import { Stack } from '@mui/material';
import { ROUTES } from '@/utils/constants';
const Logo = () => {
  return <Stack component={Link} href={ROUTES.root.href} data-sentry-element="Stack" data-sentry-component="Logo" data-sentry-source-file="Logo.tsx">
      <Image src={'/images/zeema-logo.svg'} alt='Zeema Logo' width={100} height={40} data-sentry-element="Image" data-sentry-source-file="Logo.tsx" />
    </Stack>;
};
export default memo(Logo);